import React, {useState, useEffect} from "react";
import {functions} from "../../../constants/common-functions";


export default function EditPanelInputSelectFromDbConcatenation({thisRef, restUrl}){
	
	const [options, setOptions] = useState([]);
	
	useEffect(() => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/" + restUrl, setOptions);
	}, [restUrl]);
	
	
	const thisStyle = {
		display:"flex",
		width:"313px",
		height:"32px",
		border:"1px solid #999",
		color:"black",
		backgroundColor:"rgba(0,0,0,0)",
		borderRadius:"4px",
		paddingLeft:"10px",
		fontSize:"12px",
		fontFamily:"helvetica"
	};
	
	const optionDisplay = options.map((item, index) => 
		<option value={item.id}>
			{item.name}
		</option>
	);
	
	return (
		<select style={thisStyle} ref={thisRef}>
			<option value="-100">Select</option>
			{optionDisplay}
		</select>
	);
}